import { SetUp } from "./SetUp";

export default SetUp;
